import Vue from "vue";
import App from "./App.vue";
import Router from "vue-router";
import store from "./store/index";
import Antd, { Form } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import moment from "moment";
import "moment/locale/zh-cn";
import event from "./fn/event";
import routes from "./router";
import { hasLogin, hasRoutePerm, getUser } from "@/store";
import cloneDeep from "lodash/cloneDeep";
import stores from "@/store/index";
import LazyInput from "@/components/lazyinpt.vue";
import i18n from "./lang";
import { message } from "ant-design-vue";
// import ElementUI from 'element-ui'

// import { DatePicker} from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false;
Vue.prototype.$form = Form;
Vue.config.silent = true;
Vue.use(Antd);
// Vue.use(ElementUI)
// Vue.use(DatePicker)

Vue.use(Router);
// 设置周开始为周日（默认为周一）
// moment.updateLocale('zh-cn', { week: { dow: 0 } } as any)
// 设置 moment 的语言为简体中文
(window as any).storeState = cloneDeep(stores.state);

Vue.prototype.$form = Form;

Vue.component("LazyInput", LazyInput);

moment.locale("zh-cn");

const router = new Router({
  routes,
  mode: "history",
  scrollBehavior(to: any, from: any) {
    return { x: 0, y: 0 };
  },
});

event.on(
  {
    ajax401() {
      router.push({ name: "login" });
    },

    ajax403() {
      // alert('权限不足')
      router.push({ name: "首页" });
      message.error("权限不足");
    },
  },
  false
);

router.beforeEach(async (to: any, from: any, next: any) => {
  if (!to.meta.unauth && !hasLogin()) {
    next({ name: "login" });
  } else {
    next();
  }
});

if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
}

// router.afterEach((to: any, from: any) => {
//   window.scrollTo(0, 0)
// })

new Vue({
  router,
  store,
  i18n,
  render: (h: any) => h(App),
}).$mount("#app");
